import { Hooper, Slide, Pagination as HooperPagination } from 'hooper';
class HooperClass {
    constructor() { }
    async init(target) {
        new Vue({
            el: target,
            components: {
                hooper: Hooper,
                slide: Slide,
                HooperPagination,
            },
            mounted: function () {
                this.$refs.hooper.updateWidth();
            },
        });
    }
}
export default new HooperClass();
